import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, of } from 'rxjs';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { Indirizzo } from 'src/app/shared/models/indirizzo.model';

@Component({
  selector: 'app-gestione-indirizzi-provvisori',
  templateUrl: './gestione-indirizzi-provvisori.component.html',
  styleUrls: ['./gestione-indirizzi-provvisori.component.scss']
})
export class GestioneIndirizziProvissoriComponent implements OnInit {

  @Input() indirizziConfermati : Indirizzo[] = [];

  public indirizziProvv$: Observable<Indirizzo[]> = of([]);
  //public indirizziConfermati$: Observable<Indirizzo[]> = of([]);

  public showConfermaDialog = false;
  public showHideDialog = false;
  public associaDisabled = true;
  public selectedIndirizzo: Indirizzo | undefined;
  public indirizzoToHide: Indirizzo | undefined;
  constructor(
    private readonly anagraficheService: AnagraficheService,
    private readonly messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.indirizziProvv$ = this.anagraficheService.indirizzi.getAllProvvisori();
    //this.indirizziConfermati$ = this.anagraficheService.indirizzi.getAllConfermati();
    this.selectedIndirizzo = {} as Indirizzo;
  }

  confirmIndirizzo(indirizzo: Indirizzo): void {
    const newIndirizzo = { ...indirizzo, isConfirmed: true };
    this.anagraficheService.indirizzi.update(newIndirizzo).subscribe(
      {
        next : () => this.successConfirmMessage(),
        error : () => this.errorConfirmMessage()
      }
    );
  }

  successConfirmMessage(): void {
    this.messageService.add({
      key: 'toast',
      severity: 'success',
      summary: 'Confermato',
      detail: 'Indirizzo confermato correttamente'
    });
  }

  errorConfirmMessage(): void {
    this.messageService.add({
      key: 'toast',
      severity: 'error',
      summary: 'Errore',
      detail: 'Non è possibile confermare l\'indirizzo'
    });
  }

  associaIndirizzo(indirizzo: Indirizzo): void {
    this.selectedIndirizzo = indirizzo;
    this.showConfermaDialog = true;
  }

  closeDialog(): void {
    this.showConfermaDialog = false;
  }

  associaIndirizzoaEsistente(selectedIndirizzo: Indirizzo | undefined, indirizzo: Indirizzo): void {
    if (selectedIndirizzo) {
      this.anagraficheService.indirizzi.cambiaindirizzo(selectedIndirizzo.indirizzoId, indirizzo.indirizzoId)
        .subscribe(() => {
          this.showConfermaDialog = false;
          this.successConfirmMessage();
        });
    }
  }

  public removeItem(indirizzo: Indirizzo): void {
    this.anagraficheService.indirizzi.delete(indirizzo).subscribe({
      next: () => {
        this.messageService.add({
          key: 'toast',
          severity: 'success',
          summary: 'Eliminazione',
          detail: 'Eliminazione Indirizzo completata'
        });
        // Refresh della lista degli indirizzi provvisori
        this.indirizziProvv$ = this.anagraficheService.indirizzi.getAllProvvisori();
      },
      error: (err: Error) => {
        if (err instanceof HttpErrorResponse && err.status === 409) {
          if (err.error?.canHide) {
            this.indirizzoToHide = indirizzo;
            this.showHideDialog = true;
          } else {
            this.messageService.add({
              key: 'toast',
              severity: 'error',
              summary: 'Errore',
              detail: err.error?.message || err.error
            });
          }
        } else {
          this.messageService.add({
            key: 'toast',
            severity: 'error',
            summary: 'Errore',
            detail: 'Si è verificato un errore. Operazione non completata'
          });
        }
      }
    });
  }

  public confirmHideIndirizzo(): void {
    if (this.indirizzoToHide) {
      this.anagraficheService.indirizzi.hide(this.indirizzoToHide).subscribe({
        next: () => {
          this.messageService.add({
            key: 'toast',
            severity: 'success',
            summary: 'Nascosto',
            detail: 'Indirizzo nascosto correttamente'
          });
          this.showHideDialog = false;
          this.indirizzoToHide = undefined;
          this.indirizziProvv$ = this.anagraficheService.indirizzi.getAllProvvisori();
        },
        error: () => {
          this.messageService.add({
            key: 'toast',
            severity: 'error',
            summary: 'Errore',
            detail: 'Non è possibile nascondere l\'indirizzo'
          });
          this.showHideDialog = false;
        }
      });
    }
  }

  public cancelHide(): void {
    this.showHideDialog = false;
    this.indirizzoToHide = undefined;
  }
}
